import type { SubmissionStatus } from "../../types/friction-finder";
import { Badge } from "../ui/badge";

const tones = {
  New: "new",
  Reviewing: "reviewing",
  Contacted: "contacted",
  Closed: "closed",
} as const;

export function StatusBadge({ status }: { status: SubmissionStatus }) {
  return <Badge tone={tones[status]}>{status}</Badge>;
}
